import React, { Component } from 'react'
import { Seo } from '../helpers/Seo'

class Home extends Component {
    render() {
        return (
            <div>
                <Seo
                    title="Personal Loan $100 Approved Without Documents in Quebec | GoodGoodFinance"
                    description="Easily compare personal loans approved without documents on GoodGoodFinance. Find the ideal option for your financial needs."
                    type="webapp"
                    name="GoodGoodFinance"
                />
                <div id="oopss">
                    <div id="error-text">
                        <img
                            src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg"
                            alt="404"
                        />
                        <span className="title_404">404 PAGE</span>
                        <p className="p-a">Page not found</p>

                        <a href="https://goodgoodfinance.com" className="link">
                            Back to home &#8618;
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home
